import React from 'react'
import PropTypes from 'prop-types'
import { renderRoutes } from 'react-router-config'

const App = ({ route }) => <div className="content">{route && renderRoutes(route.routes)}</div>

App.propTypes = {
  route: PropTypes.object
}

export default App



// WEBPACK FOOTER //
// ./src/common/ui/App.jsx